module.exports = __webpack_public_path__ + "officialStatic/img/pse2.22ff00f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/pse2.png
// module id = BZc6
// module chunks = 0